import React from "react";
import { Button } from "../../../ui/button";
import { useNavigate } from "react-router-dom";
import AudioPlayer from "./Audioplayer-error";
import Image from "../../../Tags/Image";
import { useTheme } from "../../../ThemeProvider";

export default function AccessDeniedView({ recordingUrl, callMetadata }) {
  const navigate = useNavigate();
  const { theme } = useTheme();

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] mx-auto">
   
      <div className="text-center">
     
        <div className="flex justify-center items-center mb-8">
          {theme === "dark" ? (
            <Image 
              src="/images/icons/untitledui/call-logs/403-error-dark.svg"
              alt="Access denied"
              width={240}
              height={240}
              className="no-invert"
            />
          ) : (
            <Image 
              src="/images/icons/untitledui/call-logs/403-error.svg"
              alt="Access denied"
              width={240}
              height={240}
            />
          )}
        </div>
        
        <h3 className="text-lg font-medium text-[#414651] dark:text-white mb-2 max-w-lg mx-auto">
          You don't seem to have access to this resource. If this is a mistake, please reach out to us at{' '}
          <a 
            href="mailto:support@primerole.com" 
            className="text-[#9E77ED] dark:text-[#9E77ED] hover:text-purple-800 dark:hover:text-purple-300 underline"
          >
            support@primerole.com
          </a>
        </h3>
      </div>
    </div>
  );
} 